<script lang="typescript">
	import { createEventDispatcher, onMount } from "svelte";
	import type { JitsiSettings } from "./jitsi";

	const dispatch = createEventDispatcher();

	export let jitsi: JitsiSettings;
	const { options } = jitsi;
	let api: JitsiMeetExternalAPI | null = null;
	let width: number;
	$: height = Math.round(width * 0.75);

	const startVideo = () => {
		const domain = "8x8.vc";
		const parentNode = document.querySelector("#jitsi-video-meeting");
		const jitsiOptions = {
			...jitsi,
			configOverwrite: options,
			parentNode: parentNode,
			width: "100%",
			//height: "100%",
		};
		api = new JitsiMeetExternalAPI(domain, jitsiOptions);
		api.addListener("videoConferenceJoined", () => {
			dispatch("join", {
				api: api,
			});
		});
		api.addListener("videoConferenceLeft", () => {
			dispatch("leave", {
				api: api,
			});
		});
		api.addListener("readyToClose", () => {
			if (api !== null) {
				api.dispose();
				api = null;
				startVideo();
			}
		});
	};

	onMount(() => {
		startVideo();
		return () => {
			if (api) {
				api.executeCommand("hangup");
				api.dispose();
			}
		};
	});
</script>

<div
	bind:clientWidth={width}
	style="height: {height}px;"
	id="jitsi-video-meeting"
/>
